import { ChipOverflowObserver } from './ChipOverflowObserver';

export function LoadChipOverflowObserver() {
    (window as any).observeChipOverflowByRef = function (ref: any, dotNetRef: any) {
        if (ref) {
            let observer = (window as any).ItemsManager.get(ref);
            if (!observer) {
                observer = new ChipOverflowObserver();
                (window as any).ItemsManager.add(ref, observer);
            }
            observer.observe(ref, dotNetRef);
        }
    };

    (window as any).unobserveChipOverflowByRef = function (ref: any) {
        if (ref) {
            const observer = (window as any).ItemsManager.get(ref);
            if (observer) {
                observer.dispose();
                (window as any).ItemsManager.remove?.(ref);
            }
        }
    };
}